import React from 'react';
import { Spinner } from '@canaveral/components';
import styles from './styles.scss';

const propTypes = {};

const defaultProps = {};

const SMSearchResultsLoadingIndicator = () => (
  <div className={styles.loadingIndicator}>
    <Spinner />
  </div>
);

SMSearchResultsLoadingIndicator.propTypes = propTypes;
SMSearchResultsLoadingIndicator.defaultProps = defaultProps;

export default SMSearchResultsLoadingIndicator;
